const { SRC_PATH } = require('./paths');

const KEYS = {
  id: 1,
  slug: 2,
  name: 3,
  tag: 4,
  image_url: 5,
  virtual_tour_url: 6,
  virtual_tour_url_localized: 7,
  lat: 8,
  lng: 9,
  priority: 10,
  parent_name: 11,
  hide_hot_desk_price: 12,
  hide_dedicated_desk_price: 13,
  hide_office_price: 14,
  hot_desk_price: 15,
  hot_desk_date: 16,
  dedicated_desk_price: 17,
  dedicated_desk_date: 18
};

let j = 19;

for (let i = 1; i <= 50; i++) {
  KEYS[`office_${i}_price`] = j++;
  KEYS[`office_${i}_date`] = j++;
}

KEYS.amenities = 200;
KEYS.open_date = 201;
KEYS.is_not_open = 202;
KEYS.market_id = 203;
KEYS.is_self_serve_building_and_available = 204;
KEYS.is_on_demand_enabled = 205;
KEYS.all_access_price = 206;
KEYS.country = 207;

module.exports.KEYS = KEYS;
module.exports.INVENTORY_FILE_PATH = `${SRC_PATH}/server/data/inventory.json`;
module.exports.INVENTORY_REDIS_HASH = 'www-data';
module.exports.INVENTORY_REDIS_FIELD = 'inventory';
